export * from './segmento-produto.pipe';
